<ng-container *ngrxLet="isLoading$; let loading">
  @if (!loading) {
    <ng-container *ngrxLet="selectUnsavedDoors$; let unsaved">
      <div class="w-100 h-100">
        <div class="ui-tab doors-wrapper flex-col start-start gap-24">
          @if (unsaved?.length) {
            <div class="unsaved-wrapper flex-col start-center">
              <div class="unsaved-header flex-row space-between-center">
                <div class="flex-col space-between-center gap-8">
                  <div class="unsaved-label">{{ 'DOORS.TITLE'|translate }}</div>
                </div>
                <div class="flex-row gap-5">
                  <div class="flex-row gap-5">
                    <!--                  <ui-button colorText="#344054"-->
                    <!--                             colorBgr="#ffffff"-->
                    <!--                             colorBorder="#D0D5DD"-->
                    <!--                             text="View more"-->
                    <!--                             (click)="viewMore()"-->
                    <!--                  ></ui-button>-->
                  </div>
                </div>
              </div>
              <div class="unsaved-list flex-row start-start">
                <div class="flex-row start-center flex-wrap gap-16">
                  @for (door of unsaved; track door.id) {
                    <ui-door-icon
                      [door]="door"
                      (add)="add(door)"
                    ></ui-door-icon>
                  }
                </div>
              </div>
            </div>
          }

          @if (!hasTableData && !unsaved?.length) {
            <ui-no-data class="w-100"
                        [imgSrc]="noResults.imgSrc"
                        [description]="noResults.description | translate"
            >
            </ui-no-data>
          } @else if (!hasTableData) {
            <div class="w-100 flex center-center">
              <ui-no-data
                [imgSrc]="noSaved.imgSrc"
                [title]="noSaved.title | translate"
                [description]="noSaved.description | translate"
              ></ui-no-data>
            </div>
          } @else {
            <div class="mb-8">{{ 'DOORS.EXISTING'|translate }}</div>
            <div class="p-r search-bar">
              <mat-icon svgIcon="search" class="search-icon"></mat-icon>
              <input class="ui-input" [(ngModel)]="query" [placeholder]="'DOORS.PLACEHOLDERS.EXISTING_SEARCH'|translate"/>
            </div>
            <div class="table-wrapper h-100 w-100">
              @if (tableConfig(); as config) {
                <ui-dataset-table
                  [data]="displayedDoors"
                  [config]="config"
                  (rowAction)="onRowAction($event)"
                ></ui-dataset-table>
              }
            </div>

            <!-- CELL TEMPLATES -->
            <ng-template #imageCell let-row>
              <img [appAuthSrc]="img(row)" class="door-image" alt="">
            </ng-template>

            <ng-template #nameCell let-row>
              @if (isEditing(row.id)) {
                <input
                  type="text"
                  class="ui-input"
                  [(ngModel)]="editableDoor()!.name"
                  style="width: 100%"
                />
              } @else {
                <div uiTruncateText>{{ row.name }}</div>
              }
            </ng-template>
          }
        </div>
      </div>
    </ng-container>
  } @else {
    <ui-preloader [color]="PreloaderColor.blue"></ui-preloader>
  }
</ng-container>
